import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { useIdleTimer } from "react-idle-timer";

// Import components
import Website from './views/Website';
import Home from "./views/Home";
import Login from "./views/Login";
import Signup from "./views/Signup";
import Quiz from "./views/Quiz";
import HalalVSHaram from "./views/HalalVSHaram";
import Leaderboard from "./views/Leaderboard";
import FillInTheBlanks from "./views/FillInTheBlanks";
import Flashcards from "./views/Flashcards";
import FigureMatchGame from "./views/FigureMatchGame";
import About from "./views/About";
import PublicRoute from "./components/PublicRoute";
import { PreloadProvider } from "./context/PreloadContext";
import JourneyPage from "./views/JourneyPage";
import Settings from "./views/Settings";
import Profile from "./views/Profile";
import PrivateRoute from "./components/PrivateRoute";
import WaitlistPage from './WaitlistPage';
import AppDownloadPage from "./views/AppDownloadPage";

function App() {

    useEffect(() => {
        const handleActivity = () => {
            // Logic for handling user activity
        };
        window.addEventListener("mousemove", handleActivity);
        window.addEventListener("keydown", handleActivity);
        return () => {
            window.removeEventListener("mousemove", handleActivity);
            window.removeEventListener("keydown", handleActivity);
        };
    }, []);

    const onIdle = () => {
        // Logic for when the user is idle
    };

    useIdleTimer({
        onIdle,
        timeout: 1000 * 60 * 5, // 5 minutes
        promptBeforeIdle: 1000 * 30,
        throttle: 500,
    });

    return (
        <PreloadProvider>
            <div className="App">
                <Routes>
                    <Route path="/" element={<Website />} />
                    <Route path="/privacy" element={<Website page="privacy" />} />
                    <Route path="/terms" element={<Website page="terms" />} />
                    <Route path="/home" element={<Home />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/settings" element={<Settings />} />
                    <Route path="/profile" element={<Profile />} />
                    <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
                    <Route path="/signup" element={<PublicRoute><Signup /></PublicRoute>} />
                    <Route path="/leaderboard" element={<Leaderboard />} />
                    <Route path="/quiz" element={<Quiz />} />
                    <Route path="/halalvsharam" element={<HalalVSHaram />} />
                    <Route path="/ayah-blanks" element={<FillInTheBlanks />} />
                    <Route path="/flashcards" element={<Flashcards />} />
                    <Route path="/figurematchgame" element={<FigureMatchGame />} />
                    <Route path="/figure-match-game" element={<FigureMatchGame />} />
                    <Route path="/waitlist" element={<WaitlistPage />} />
                    <Route path="/app" element={<AppDownloadPage />} />
                    <Route path="/journey" element={<PrivateRoute><JourneyPage /></PrivateRoute>} />
                </Routes>
            </div>
        </PreloadProvider>
    );
}

export default App;
